module.exports = __webpack_public_path__ + "static/media/IMG_2194.bafcd946.jpg";